module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_9005.51610cb6.png";